/* eslint-disable react/no-danger */
import {
  BasketIcon,
  Box,
  Divider,
  GKButton,
  Grid2,
  NotificationsIcon,
  RiskProfileIcon,
  Show,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TermIcon,
  Typography,
  VolatileIcon,
} from "components";
import { isEmpty } from "lodash";
import {
  handleRemoveUnderscore,
  moneyCommaSeparator,
  numberToCurrency,
} from "utils";
import { handleCapitalize } from "utils/common";
import { returnPositiveNegativeColor } from "utils/helpers";
import { ThemeContainer } from "utils/Theme";
import { dummyBasketList } from "../utils";

const BasketListSection = () => {
  const { theme } = ThemeContainer();

  return (
    <Grid2 container width={"100%"} maxWidth={{ xs: "100vw", md: "1192px" }}>
      <Grid2 size={12} container spacing={2} px={{ xs: 2 }} py={{ xs: 6 }}>
        <Grid2
          size={12}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box
            bgcolor={"#EEF5FA"}
            p={3}
            width={90}
            height={90}
            borderRadius={200}
          >
            <BasketIcon width={"100%"} height={"100%"} color="#697586" />
          </Box>
        </Grid2>
        <Grid2 size={12} textAlign={"center"} mb={4}>
          <Typography
            id="basket-list"
            fontWeight={600}
            fontSize={{ xs: 14, md: 32 }}
          >
            Pick your Basket
          </Typography>
          <Typography
            color={"var(--neutral-500)"}
            fontSize={" clamp(0.75rem, 0.125rem + 2vw, 1.25rem)"}
          >
            We have professionally crafted baskets to suit your investment
            needs{" "}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            {dummyBasketList?.map((dataItem: any, index: any) => {
              return (
                <Grid2 size={{ xs: 12 }} overflow={"hidden"} key={index}>
                  <Box key={index} minWidth={{ xs: "100%" }}>
                    <Box key={index}>
                      <Grid2
                        container
                        key={index}
                        bgcolor={theme.palette.light.main}
                        border={{
                          md: "none",
                          xs: `solid 1px ${theme.palette.border.main}`,
                        }}
                        borderBottom={{
                          xs: "",
                          md: `solid 1px ${theme.palette.border.main}`,
                        }}
                        borderRadius={{
                          xs: 2,
                          md: 0,
                        }}
                        p={2}
                        pb={4}
                        spacing={1}
                      >
                        <Grid2
                          size={12}
                          display={"flex"}
                          alignItems={"center"}
                          gap={1}
                          overflow={"auto"}
                        >
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap={0.5}
                            bgcolor={`#EEF5FA`}
                            p={1}
                            borderRadius={2}
                            sx={{ borderBottomLeftRadius: 0 }}
                          >
                            <BasketIcon />
                            <Typography fontSize={12}>
                              {dataItem?.basketType === "Model"
                                ? "Model Portfolio"
                                : "Stock Recommendation"}
                            </Typography>
                          </Box>
                        </Grid2>
                        <Grid2
                          container
                          size={{ xs: 12, md: 6.5 }}
                          display={"flex"}
                          alignItems={"center"}
                          gap={2}
                        >
                          <Grid2 size={"auto"}>
                            <div
                              style={{
                                height: "60px",
                                width: "60px",
                                minWidth: "50px",
                                borderRadius: 8,
                                background: `${theme.palette.primary.main}1a`,
                              }}
                            >
                              {dataItem?.basketLogo ? (
                                <img
                                  style={{
                                    height: "100%",
                                    borderRadius: 8,
                                    width: "100%",
                                    border: `solid 1px var(--grey-100)`,
                                  }}
                                  src={dataItem?.basketLogo || "/errorImg.svg"}
                                  alt=""
                                />
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    borderRadius: 8,
                                    width: "100%",
                                  }}
                                >
                                  <Typography
                                    fontWeight={600}
                                    fontSize={24}
                                    textTransform={"capitalize"}
                                    color={theme.palette.primary.main}
                                  >
                                    {dataItem?.name?.charAt(0)}
                                  </Typography>
                                  <Typography
                                    fontWeight={600}
                                    fontSize={24}
                                    textTransform={"capitalize"}
                                    color={theme.palette.primary.main}
                                  >
                                    {dataItem?.name?.charAt(1)}
                                  </Typography>
                                </div>
                              )}
                            </div>
                          </Grid2>
                          <Grid2 size={"grow"} container spacing={1}>
                            <Grid2 size={12}>
                              <Typography
                                fontWeight={600}
                                fontSize={18}
                                textAlign={"left"}
                                textOverflow={{ xs: "ellipsis" }}
                                overflow={{ xs: "hidden" }}
                                whiteSpace={{ xs: "nowrap" }}
                              >
                                {dataItem?.name}
                              </Typography>
                              <Box
                                textAlign={"left"}
                                fontWeight={400}
                                fontSize={14}
                                color="var(--neutral-500)"
                                textOverflow={{ xs: "ellipsis" }}
                                overflow={{ xs: "hidden" }}
                                whiteSpace={{ xs: "nowrap" }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: dataItem?.overview || "",
                                  }}
                                />
                              </Box>
                            </Grid2>

                            <Grid2
                              size={12}
                              gap={1}
                              display={{ xs: "none", md: "flex" }}
                            >
                              <div
                                id="basket-list"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                <Show.When
                                  isTrue={
                                    !isEmpty(dataItem?.riskProfile) ||
                                    !isEmpty(dataItem?.volatility) ||
                                    !isEmpty(dataItem?.timePeriod)
                                  }
                                >
                                  {[
                                    {
                                      name: "Risk",
                                      value: dataItem?.riskProfile[0] || "-",
                                      icon: RiskProfileIcon,
                                      withSeperator: true,
                                      iconColor: theme.palette.error.main,
                                    },
                                    {
                                      name: "Volatility",
                                      value: dataItem?.volatility || "-",
                                      icon: VolatileIcon,
                                      withSeperator: true,
                                      iconColor: theme.palette.warning.main,
                                    },
                                    {
                                      name: "Term",
                                      value: dataItem?.timePeriod || "-",
                                      icon: TermIcon,
                                      withSeperator: false,
                                      iconColor: theme.palette.info.main,
                                    },
                                  ]?.map((item, i) => {
                                    return (
                                      <Show.When
                                        isTrue={!isEmpty(item.value)}
                                        key={i}
                                      >
                                        <Box
                                          display={"flex"}
                                          alignItems={"center"}
                                          gap={0.5}
                                          key={i}
                                        >
                                          <Typography
                                            fontSize={12}
                                            color="var(--neutral-500)"
                                          >
                                            {item.name}:
                                          </Typography>
                                          <Box
                                            display={"flex"}
                                            alignItems={"center"}
                                            gap={0.5}
                                          >
                                            <item.icon color="var(--grey-500)" />
                                            <Typography
                                              color="var(--grey-900)"
                                              fontSize={12}
                                              fontWeight={600}
                                            >
                                              {handleRemoveUnderscore(
                                                handleCapitalize(item?.value),
                                              ) || "-"}
                                            </Typography>
                                          </Box>
                                        </Box>
                                        {item.withSeperator && (
                                          <Divider
                                            orientation="vertical"
                                            sx={{ height: "20px" }}
                                          />
                                        )}
                                      </Show.When>
                                    );
                                  })}
                                </Show.When>
                              </div>
                            </Grid2>
                          </Grid2>
                          <Grid2
                            size={12}
                            gap={1}
                            display={{ md: "none", xs: "flex" }}
                          >
                            <div
                              id="basket-list"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                width: "100%",
                              }}
                            >
                              <Show.When
                                isTrue={
                                  !isEmpty(dataItem?.riskProfile) ||
                                  !isEmpty(dataItem?.volatility) ||
                                  !isEmpty(dataItem?.timePeriod)
                                }
                              >
                                <TableContainer
                                  sx={{
                                    border: "none",
                                    bgcolor: "#F8F8F8",
                                  }}
                                >
                                  <Table>
                                    <TableBody>
                                      <TableRow>
                                        {[
                                          {
                                            name: "Risk",
                                            value:
                                              dataItem?.riskProfile[0] || "-",
                                            icon: RiskProfileIcon,
                                            withSeperator: true,
                                            iconColor: theme.palette.error.main,
                                          },
                                          {
                                            name: "Volatility",
                                            value: dataItem?.volatility || "-",
                                            icon: VolatileIcon,
                                            withSeperator: true,
                                            iconColor:
                                              theme.palette.warning.main,
                                          },
                                          {
                                            name: "Term",
                                            value: dataItem?.timePeriod || "-",
                                            icon: TermIcon,
                                            withSeperator: false,
                                            iconColor: theme.palette.info.main,
                                          },
                                        ]?.map((item, i) => {
                                          return (
                                            <Show.When
                                              isTrue={!isEmpty(item.value)}
                                              key={i}
                                            >
                                              <TableCell
                                                key={i}
                                                style={{
                                                  border: "none",
                                                  padding: 12,
                                                  background:
                                                    "var(--grey-bg-100)",
                                                }}
                                              >
                                                <Typography
                                                  fontSize={12}
                                                  color="var(--neutral-500)"
                                                >
                                                  {item.name}
                                                </Typography>
                                                <Box
                                                  display={"flex"}
                                                  alignItems={"center"}
                                                  gap={0.5}
                                                >
                                                  <Typography
                                                    fontSize={12}
                                                    color="var(--grey-900)"
                                                    fontWeight={600}
                                                  >
                                                    {handleRemoveUnderscore(
                                                      handleCapitalize(
                                                        item?.value,
                                                      ),
                                                    ) || "-"}
                                                  </Typography>
                                                </Box>
                                              </TableCell>
                                            </Show.When>
                                          );
                                        })}
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Show.When>
                            </div>
                          </Grid2>
                        </Grid2>
                        <Grid2
                          container
                          size={{ xs: 12, md: 3 }}
                          display={"flex"}
                          justifyContent={{ xs: "flex-start", sm: "" }}
                          flexDirection={{ xs: "column", md: "row" }}
                          alignItems={{ xs: "flex-start", md: "center" }}
                          gap={{ xs: 1, md: 4 }}
                          p={dataItem?.basketType !== "Asset" ? 0 : 1.5}
                        >
                          <Show.When isTrue={dataItem?.basketType !== "Asset"}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                flexDirection: { xs: "row", md: "column" },
                              }}
                            >
                              <Typography fontSize={12}>
                                Min. Investment
                              </Typography>
                              <Typography fontWeight={600} fontSize={16}>
                                {numberToCurrency(dataItem.minInvestment)}
                              </Typography>
                            </Box>
                            <Divider
                              orientation="vertical"
                              sx={{
                                display: { xs: "none", md: "flex" },
                                height: 40,
                              }}
                            />

                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                                flexDirection: { xs: "row", md: "column" },
                              }}
                            >
                              <Typography fontSize={12}>Returns</Typography>
                              <Typography
                                fontWeight={600}
                                fontSize={16}
                                color={returnPositiveNegativeColor(
                                  dataItem?.xirr || 0,
                                )}
                              >
                                {moneyCommaSeparator(dataItem.xirr || 0)}%
                              </Typography>
                            </Box>
                          </Show.When>
                        </Grid2>
                        <Grid2
                          size={{
                            xs: 12,
                            md: 2.5,
                          }}
                          container
                          display={"flex"}
                          flexDirection={{ xs: "row-reverse", md: "column" }}
                          borderTop={{
                            md: "none",
                            xs: `solid 1px ${theme.palette.border.main}`,
                          }}
                          pt={2}
                        >
                          <Grid2 size={{ xs: 6, md: 12 }}>
                            <GKButton
                              fullWidth
                              variant="contained"
                              startIcon={<NotificationsIcon />}
                            >
                              {dataItem?.isSubscribed
                                ? "Invest Now"
                                : "Subscribe Now"}
                            </GKButton>
                          </Grid2>
                          <Grid2
                            size={{ xs: 6, md: 12 }}
                            display={
                              dataItem?.defaultFeePlans?.subscriptionFee
                                ? "flex"
                                : "none"
                            }
                            justifyContent={"space-between"}
                            flexDirection={{ xs: "column", md: "row" }}
                            alignItems={{ xs: "center", md: "center" }}
                          >
                            <GKButton
                              sx={{
                                color: "var(--neutral-500)",
                                "&:hover": { background: "transparent" },
                                display: { xs: "none", md: "flex" },
                                "&.MuiButtonBase-root": {
                                  p: "0 !important",
                                },
                              }}
                              fullWidth
                              color="dark"
                              disableFocusRipple
                              disableRipple
                            >
                              View Pricing Plan
                            </GKButton>
                            <GKButton
                              variant="outlined"
                              fullWidth
                              color="dark"
                              disableFocusRipple
                              disableRipple
                              sx={{
                                color: "#222",
                                display: { md: "none", xs: "flex" },
                              }}
                            >
                              View Pricing Plan
                            </GKButton>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </Box>
                </Grid2>
              );
            })}
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default BasketListSection;
